<template>
	<el-drawer
		v-model="open"
		direction="ttb"
		:before-close="handleClose"
		:modal-class="'searchdrawer'"
		:withHeader="false"
		:size="isSuperUser ? '150px' : '80px'"
		:show-close="true"
	>
		<template #default>
			<div class="drawer--inner">
				<el-input v-model="searchTerm" placeholder="Suche" @keyup.enter="doSearch()" />
				<TheButton type="danger" :onlyIcon="true" @buttonclick="doSearch()">
					<el-icon><Search /></el-icon>
				</TheButton>

				<el-icon class="drawer--close" @click="handleClose"><Close /></el-icon>
			</div>
		</template>
		<template #footer v-if="isSuperUser">
			<el-radio-group v-model="searchType">
				<el-radio value="beschwerden">Beschwerden</el-radio>
				<el-radio value="faelle">Fälle</el-radio>
				<el-radio value="werberatsentscheidungen">Werberatsentscheidungen</el-radio>
				<el-radio value="user">User</el-radio>
				<el-radio value="kontakte">Kontakte</el-radio>
			</el-radio-group>
		</template>
	</el-drawer>
</template>

<script lang="ts">
import TheButton from './TheButton.vue';
import { Search, Close } from '@element-plus/icons-vue';
import { useStore, authUser } from '@/store';
import { computed } from 'vue';

export default {
	name: 'SearchDrawer',
	data() {
		return {
			searchTerm: '',
			searchType: 'beschwerden',
			isSuperUser: false,
		};
	},
	setup() {
		const store = useStore();
		const searchDrawerOpen = computed(() => store.state.searchDrawerOpen);

		return {
			store,
			searchDrawerOpen,
			user: authUser,
		};
	},

	computed: {
		open() {
			return this.searchDrawerOpen;
		},
	},
	components: {
		TheButton,
		Search,
		Close,
	},
	methods: {
		handleClose() {
			this.store.dispatch('toggleSearchDrawerOpen');
		},
		doSearch() {
			if (this.searchTerm == '') return;
			this.handleClose();

			switch (this.searchType) {
				case 'beschwerden':
					this.$router.push({
						path: '/beschwerden',
						query: { searchTerm: this.searchTerm },
					});
					break;
				case 'faelle':
					this.$router.push({
						path: '/faelle',
						query: { searchTerm: this.searchTerm },
					});
					break;
				case 'werberatsentscheidungen':
					this.$router.push({
						path: '/werberatsentscheidungen',
						query: { searchTerm: this.searchTerm },
					});
					break;
				case 'user':
					this.$router.push({
						path: '/user',
						query: { searchTerm: this.searchTerm },
					});
					break;
				case 'kontakte':
					this.$router.push({
						path: '/kontakte',
						query: { searchTerm: this.searchTerm },
					});
					break;

				default:
					break;
			}
		},
	},
	watch: {
		open(val) {
			if (val === false) {
				this.searchTerm = '';
			}
		},
	},
	mounted() {
		if (this.user) {
			const userRoles = this.user.roles ? this.user.roles.map((role) => role.name) : [];
			this.isSuperUser = userRoles.includes('Admin') || userRoles.includes('Super-Admin');
			if (!this.isSuperUser) {
				// werberat/vorstand/etc can only search for Fälle
				this.searchType = 'faelle';
			}
		}
	},
};
</script>

<style lang="scss">
@use '../scss/vars.scss' as *;

.searchdrawer {
	.el-drawer__body {
		display: flex;
		justify-content: center;

		.drawer--inner {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			width: 100%;
			position: relative;

			.drawer--close {
				position: absolute;
				right: 10rem;
				top: 50%;
				transform: translateY(-50%);
				font-size: 1.5rem;
				cursor: pointer;
			}
			.el-input {
				width: 100%;
				max-width: 500px;
				margin-right: 1rem;
				height: 40px;
			}
		}
	}

	.el-drawer__footer {
		display: flex;
		justify-content: center;
		background-color: var(--el-color-primary);
		padding-top: var(--el-drawer-padding-primary);
		.el-radio__label {
			color: #fff;
			font-size: 1rem;
			font-weight: 400;
		}

		.el-radio__inner {
			border: 4px solid #fff;

			&::after {
				background-color: var(--el-color-primary);
			}
		}
	}
}
@media screen and (max-width: $mobile_maxwidth) {
	.searchdrawer {
		.el-drawer__body {
			.drawer--inner {
				.drawer--close {
					display: none;
				}
			}
		}
	}
}
</style>
